import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {Prestatie, PrestatieDto} from './prestatie';
import {map} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ClientZoekMethode} from '../client/clientnummer-selector/clientnummer';
import UitgevoerdeTaak from './uitgevoerde-taak';
import {PageRequest} from '../core/pagination/page-request';
import {Page, PageDto} from '../core/pagination/page';

@Injectable({
  providedIn: 'root'
})
export class PrestatieService {
  private http = inject(HttpClient);

  startPrestatie$(clientId: string, startMethode: ClientZoekMethode): Observable<Prestatie> {
    return this.http
      .post<PrestatieDto>(`${environment.apiUrl}/prestaties`, {clientId, startMethode})
      .pipe(map(dto => Prestatie.deserialize(dto)));
  }

  stopPrestatie$(prestatieId: string, stopMethode: ClientZoekMethode): Observable<Prestatie> {
    return this.http
      .post<PrestatieDto>(`${environment.apiUrl}/prestaties/${prestatieId}/stop`, {stopMethode})
      .pipe(map(dto => Prestatie.deserialize(dto)));
  }

  getPrestatie$(prestatieId: string): Observable<Prestatie> {
    return this.http
      .get<PrestatieDto>(`${environment.apiUrl}/prestaties/${prestatieId}`)
      .pipe(map(dto => Prestatie.deserialize(dto)));
  }

  getActievePrestatie$(): Observable<Prestatie | undefined> {
    return this.http
      .get<PrestatieDto>(`${environment.apiUrl}/prestaties/actief`)
      .pipe(map(dto => !!dto ? Prestatie?.deserialize(dto) : undefined));
  }

  selectTaak(prestatieId: string, taak: UitgevoerdeTaak): Observable<Prestatie> {
    return this.http
      .put<PrestatieDto>(`${environment.apiUrl}/prestaties/${prestatieId}/diensten/${taak.getDienstId()}/categorieen/${taak.getCategorieId()}/taken/${taak.getTaakId()}`, {})
      .pipe(map(dto => Prestatie.deserialize(dto)));
  }

  deselectTaak(prestatieId: string, taak: UitgevoerdeTaak): Observable<Prestatie> {
    return this.http
      .delete<PrestatieDto>(`${environment.apiUrl}/prestaties/${prestatieId}/diensten/${taak.getDienstId()}/categorieen/${taak.getCategorieId()}/taken/${taak.getTaakId()}`)
      .pipe(map(dto => Prestatie.deserialize(dto)));
  }

  getPrestatiesPage$(clientId: string, pageRequest: PageRequest<Prestatie>): Observable<Page<Prestatie>> {
    return this.http
      .post<PageDto<PrestatieDto>>(`${environment.apiUrl}/prestaties/${clientId}/page`, pageRequest)
      .pipe(map(pageDto => new Page(
        pageDto.ascending,
        pageDto.pageSize,
        pageDto.pageNumber,
        pageDto.lastPage,
        pageDto.items.map(dto => Prestatie.deserialize(dto)),
      )));
  }
}
